import { analyticsConfig } from './config';

interface PTEngineWindow extends Window {
  _pt_lt?: number;
  _pt_sp_2?: string[];
}

const PT_SCRIPT_ID = 'landing-page-ptengine-loader';

function getPtWindow() {
  return window as PTEngineWindow;
}

export function setupPtEngine() {
  const { enabled, accountId, src } = analyticsConfig.ptEngine;

  if (!enabled || typeof document === 'undefined') {
    return;
  }

  const ptWindow = getPtWindow();

  if (!ptWindow._pt_sp_2) {
    ptWindow._pt_sp_2 = [];
  }

  if (!ptWindow._pt_sp_2.includes(`setAccount,${accountId}`)) {
    ptWindow._pt_sp_2.push(`setAccount,${accountId}`);
  }

  if (!ptWindow._pt_lt) {
    ptWindow._pt_lt = Date.now();
  }

  if (document.getElementById(PT_SCRIPT_ID)) {
    return;
  }

  const script = document.createElement('script');

  script.id = PT_SCRIPT_ID;
  script.async = true;
  script.src = src;

  const firstScript = document.querySelector('script');

  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript);
    return;
  }

  document.head.appendChild(script);
}
